module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "d-flex row mx-0 space-card__wrapper px-2 py-2 ui_cursor__pointer mb-2",
    attrs: {
      "to": {
        name: 'organization-spaces',
        params: {
          id: _vm.item.id,
          partnerId: _vm.partnerId
        }
      }
    }
  }, [_c('AppPicture', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "image": _vm.image,
      "image-width": "150px",
      "image-height": "150px"
    }
  }), _c('div', {
    staticClass: "col-auto px-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column space-card__info"
  }, [_c('h3', {
    staticClass: "ui_fw__bold mb-1 ui_fz__large"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('p', {
    staticClass: "ui_fz__small mb-1"
  }, [_vm._v("Расположение: " + _vm._s(_vm.item.address))]), _c('p', {
    staticClass: "ui_fz__small mb-1"
  }, [_vm._v("Площадь, кв.м.: " + _vm._s(_vm.item.area))]), _c('p', {
    staticClass: "ui_fz__small mb-1"
  }, [_vm._v("Вместимость, чел.: " + _vm._s(_vm.item.max_persons))]), _c('p', {
    staticClass: "ui_fz__small mb-1"
  }, [_vm._v("Расположение: " + _vm._s(_vm.item.address))]), _c('p', {
    staticClass: "ui_fz__small mb-1"
  }, [_vm._v("Тип помещения: " + _vm._s(_vm.objectType))]), _c('p', {
    staticClass: "ui_fz__small"
  }, [_vm._v("Для ОВЗ: " + _vm._s(_vm.ovzAvailable))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7939c841","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/spaces/components/SpaceCard.vue
// module id = 8e805edccb48357549fb
// module chunks = 25